import { jsx as _jsx } from "react/jsx-runtime";
import { StyledProgressIndicator, ProgressIndicatorWrapper, ProgressIndicatorProgress } from './ProgressIndicator.styles';
export const ProgressIndicator = ({
  totalSteps,
  currentStepNumber
}) => {
  const currentProgress = Math.round(currentStepNumber / (totalSteps + 1) * 100);
  return /*#__PURE__*/_jsx(StyledProgressIndicator, {
    children: /*#__PURE__*/_jsx(ProgressIndicatorWrapper, {
      children: /*#__PURE__*/_jsx(ProgressIndicatorProgress, {
        "aria-label": `Step ${currentStepNumber} of ${totalSteps}`,
        use: "warning",
        value: currentProgress
      })
    })
  });
};